import 'shared/global';
import 'shows/parentalControlsPin.js';
import 'bundles/browseTracking';
import hubCollectionConfigurator from 'carousels/hubCollectionConfigurator';

hubCollectionConfigurator();
